export const SET_ADSENSE_INFO = "SET_ADSENSE_INFO";
export const SET_ADFIT_INFO = "SET_ADFIT_INFO";